import { breakpoints } from './breakpoints';
import { palette } from './palette';
import { shape } from './shape';
import { space } from './space';
import { typography } from './typography';
// Default theme.
// -----------------------------------------------------------------------------
export const defaultTheme = {
    breakpoints,
    palette,
    shape,
    space,
    typography
};
//# sourceMappingURL=theme.js.map